/**
 * Renders the buyer-selected add-on services (Tillval / Tjänster) as their own
 * rows in the order breakdown. Services are validated + priced server-side and
 * paid out in full to the seller (no commission, no VAT split).
 */
import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SERVICE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemServicesMaybe = props => {
  const { lineItems, transaction, intl } = props;

  const serviceLineItems = lineItems.filter(
    item => item.code === LINE_ITEM_SERVICE && !item.reversal
  );
  if (serviceLineItems.length === 0) {
    return null;
  }

  const serviceMeta = transaction?.attributes?.protectedData?.services || [];

  return (
    <React.Fragment>
      {serviceLineItems.map((item, i) => {
        // "Omläggning · 2 däck" (P25009-484 spec §7); older orders have no label.
        const meta = serviceMeta[i] || {};
        const title = [meta.title || 'Tillval', meta.quantityLabel].filter(Boolean).join(' · ');
        const formattedTotal = formatMoney(intl, item.lineTotal);
        return (
          <div key={`service-${i}`} className={css.lineItem}>
            <span className={css.itemLabel}>{title}</span>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </React.Fragment>
  );
};

LineItemServicesMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemServicesMaybe;
